import {ICrmSurveyForm } from "../../../models/response/crm-survey/ICrmSurveyForm";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export const objCrmSurveyFormDefine = {
    LOAD_START: "",
    LOAD_SUCCESS: [] as ICrmSurveyForm[],
    LOAD_ERROR: "",
    SELECT_START: "",
    SELECT_SUCCESS: [] as ICrmSurveyForm[],
    SELECT_ERROR: "",
    SHOW_EDIT_MODAL: {} as ICrmSurveyForm | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as ICrmSurveyForm,
    SAVE_SUCESS: {} as ICrmSurveyForm,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: ""
};

export const eCrmSurveyFormActionTypeIds = generateActionTypeIds(objCrmSurveyFormDefine, "CRM_SURVEY_FORM")
export type ICrmSurveyFormActionTypes = IGenericActionType<typeof objCrmSurveyFormDefine, "CRM_SURVEY_FORM">